export const UserTypes = {
    ENERGY_MANAGER: 'energymanager',
    ADMIN: 'admin',
    USER: 'user',
    USER_ADMIN: 'useradmin',
};
